import { PermissionListPage } from '@/features/access/pages/permission/PermissionListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/access/permission/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["auth_permissions.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PermissionListPage,
})
